var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32678 0.614258H6.63909C7.92414 0.614258 8.96587 1.57583 8.96587 2.76199V4.83335C8.96587 6.01951 7.92414 6.98108 6.63909 6.98108H2.32678C1.04174 6.98108 0 6.01951 0 4.83335V2.76199C0 1.57583 1.04174 0.614258 2.32678 0.614258ZM6.63909 5.54926C7.06511 5.54412 7.40912 5.22658 7.41469 4.83335V2.76199C7.40912 2.36875 7.06511 2.05122 6.63909 2.04608H2.32678C1.90076 2.05122 1.55676 2.36875 1.55119 2.76199V4.83335C1.55676 5.22658 1.90076 5.54412 2.32678 5.54926H6.63909Z",
    fill: "#4B4B4A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0538 0.614258H17.6732C18.9582 0.614258 20 1.57583 20 2.76199V9.28153C20 10.4677 18.9582 11.4293 17.6732 11.4293H14.0538C13.4358 11.4318 12.8424 11.2064 12.4054 10.803C11.9685 10.3997 11.7242 9.85192 11.727 9.28153V2.76199C11.727 1.57583 12.7687 0.614258 14.0538 0.614258ZM17.6732 9.99744C18.1015 9.99744 18.4488 9.67692 18.4488 9.28153V2.76199C18.4432 2.36875 18.0992 2.05122 17.6732 2.04608H14.0538C13.6254 2.04608 13.2782 2.3666 13.2782 2.76199V9.28153C13.2753 9.47218 13.3562 9.65579 13.5022 9.79062C13.6483 9.92544 13.8472 10 14.0538 9.99744H17.6732Z",
    fill: "#4B4B4A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0538 13.9779H17.6732C18.9583 13.9779 20 14.9395 20 16.1256V17.5574C20 18.7436 18.9583 19.7052 17.6732 19.7052H14.0538C12.7687 19.7052 11.727 18.7436 11.727 17.5574V16.1256C11.727 14.9395 12.7687 13.9779 14.0538 13.9779ZM17.6732 18.2733C18.0992 18.2682 18.4432 17.9507 18.4488 17.5574V16.1256C18.4432 15.7324 18.0992 15.4149 17.6732 15.4097H14.0538C13.6254 15.4097 13.2782 15.7302 13.2782 16.1256V17.5574C13.2782 17.9528 13.6254 18.2733 14.0538 18.2733H17.6732Z",
    fill: "#4B4B4A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32678 9.52017H6.63909C7.92414 9.52017 8.96587 10.4817 8.96587 11.6679V17.5574C8.96587 18.7436 7.92414 19.7052 6.63909 19.7052H2.32678C1.04174 19.7052 0 18.7436 0 17.5574V11.6679C0 10.4817 1.04174 9.52017 2.32678 9.52017ZM6.63909 18.2733C7.06511 18.2682 7.40912 17.9507 7.41469 17.5574V11.6679C7.40912 11.2747 7.06511 10.9571 6.63909 10.952H2.32678C1.90076 10.9571 1.55676 11.2747 1.55119 11.6679V17.5574C1.55676 17.9507 1.90076 18.2682 2.32678 18.2733H6.63909Z",
    fill: "#4B4B4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.89ed1a4ddb419ba8e6dac89641670aec.svg";
export { ForwardRef as ReactComponent };